import { useLocation } from 'react-router-dom'

import { useEffect, useState } from 'react'
// import { Calculation } from 'pages/Vehicle/helpers/calculation'
// import { toString } from 'lodash'
import _ from 'lodash'
import { VehicleCalculation } from 'pages/Vehicle/helpers/vehicleCalculation'
import { useDataByCountryCodeLazyService } from 'services/useRegionService'

const useVehicleCalculator = () => {
  const local_vehicle_data = JSON.parse(localStorage.getItem('hv_data') || '[]')

  const location = useLocation<any>()
  const { state } = location
  const { replacement_electric_vehicle_chassis } = state
  const { getRegionByCode, loading } = useDataByCountryCodeLazyService()
  const [regionData, setRegionData] = useState()

  const [selectedVehicleData, setSelectedVehicleData] = useState<any>({})

  const [settings, setSettings] = useState<any>({})

  const newCalculation = new VehicleCalculation(
    settings,
    selectedVehicleData,
    regionData,
    local_vehicle_data,
  )

  // const cost_per_kwh = Calc.get_cost_per_kwh()
  const total_cost_saving = newCalculation.get_total_cost_saving()
  const total_emissions_reduced = newCalculation.get_total_emissions_reduced()
  const diesel_vehicle = newCalculation.get_diesel_vehicle()
  const diesel_vehicle_range = newCalculation.get_diesel_vehicle_range()
  const ev_vehicle_range = newCalculation.get_ev_vehicle_range()

  const range_data = {
    diesel_vehicle_range,
    ev_vehicle_range,
  }

  console.log(newCalculation.result, 'result')

  const chartData = {
    diesel_depreciation: newCalculation.get_diesel_depreciation(),
    electric_depreciation: newCalculation.get_electric_depreciation(),
    diesel_energy_cost: newCalculation.get_fuel_cost_diesel(),
    electric_energy_cost: newCalculation.get_fuel_cost_electric(),
    diesel_maintenance: newCalculation.get_diesel_maintenance(),
    electric_maintenance: newCalculation.get_electric_maintenance(),
    battery_replacement: newCalculation.get_battery_replacement(),
  }

  const co2Chart = {
    co2_diesel: newCalculation.get_co2_diesel(),
    co2_electric: newCalculation.get_co2_electric(),
  }

  useEffect(() => {
    const vehicle = _.find(local_vehicle_data, { id: replacement_electric_vehicle_chassis })
    setSelectedVehicleData({ ...vehicle, ...state })
  }, [state && replacement_electric_vehicle_chassis]) //eslint-disable-line

  useEffect(() => {
    getRegionByCode({
      variables: {
        region_code: 'NSW',
      },
    })
      .then((res) => setRegionData(res.data.region))
      .catch((err) => console.error(err))
  }, []) //eslint-disable-line

  return {
    setSettings,
    selectedVehicleData,
    regionData,
    total_cost_saving,
    total_emissions_reduced,
    chartData,
    loading,
    diesel_vehicle,
    co2Chart,
    range_data,
  }
}

export default useVehicleCalculator
